import React from 'react';

import { useLanguageContext } from './ui/LanguageProvider';

const LoadingScreen = () => {
  const { t, isRTL } = useLanguageContext();

  return (
    <div 
      className={`min-h-screen bg-background flex items-center justify-center ${isRTL ? 'rtl' : 'ltr'}`}
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      <div className="text-center space-y-6">
        {/* Loading Spinner */}
        <div className="relative mx-auto w-16 h-16">
          <div className="absolute top-0 left-0 w-16 h-16 border-4 border-primary/20 rounded-full"></div>
          <div className="absolute top-0 left-0 w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
        </div>
        
        {/* Loading Text */}
        <div className="space-y-2">
          <h3 className="text-xl font-semibold text-foreground">
            {t('loading')}
          </h3>
          <p className="text-muted-foreground">
            {t('dashboard')}
          </p>
        </div>
        
        {/* Loading Progress Indicator */}
        <div className="w-64 mx-auto">
          <div className="h-2 bg-muted rounded-full overflow-hidden">
            <div className="h-full bg-primary rounded-full animate-pulse"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;